
export const serviceUpload = {
    uploadimage
}
// function uploadimage(image) {
//
//     const formData = new FormData()
//     formData.append('file', image);
//     return fetch('https://cdn.irmastore.id:9780/upload', {
//         method: 'POST',
//         body: formData,
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')
//         },
//     }).then(handleResponse)
//         .then(data => {
//             return data;
//         });
// }

function uploadimage(image) {

    const formData = new FormData()
    formData.append('file', image);
    return fetch('https://cdn.irmastore.id/upload', {
        method: 'POST',
        body: formData,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
    }).then(handleResponse)
        .then(data => {
            return data;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if(response.status===200){
            if(data.access_token){
                return data;
            }
        }

        if (!data.success) {
            if (response.status === 401) {
                console.log("CALL LOGOUT");
                localStorage.setItem('token',null);
                localStorage.clear();
                location.reload(true);
            }
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
